<template>
    <a class="boardEventStyle"
       @click="boardDetailMove(boardId, data.oBoard.nBoardNum, data.oBoard.oAuthorizeAccessRead)"
    >
        <div class="flex board-list-thumb" :class="boardReadCheck(data.oBoard.nBoardNum)">
            <!-- 썸네일 -->
            <div class="board-list-thumb-img">
                <img width="100%" v-lazy.container="data.oBoard.oEventInfo.strBannerImg" />
            </div>
            <div class="board-list-thumb-subject">
                <!-- 게시글 제목 -->
                <h3>{{ data.oBoard.strBoardTitle }}</h3>
                <!-- 이벤트 정보 -->
                <h6>
                    <span :class="((data.oBoard.oEventInfo.strApplyCode == 'END')) ? 'tag-gray' : 'tag-blue' ">
                        {{ data.oBoard.oEventInfo.strApplyCode | eventApplyName}}
                    </span>
                </h6>
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        name: 'boardEventStyle',
        data() {
            return {
                boardId:this.storageGet('vuex','boardActiveCode'),  // 현재 게시글 카테고리
            }
        },
        props: ['data','popup'],
        // 계산된 속성
        computed: {
        },
        // 감시자
        watch: {
        },
        filters: {
            // 이벤트 코드 한글명 변경
            eventApplyName:function (value){
                if (value == 'END') {
                    return '종료';
                }else if (value == 'DONE'){
                    return '당첨자발표';
                }else{
                    return '참여가능';
                }
            },
        },
        // $el 생성전
        created() {
        },
        // $el 생성후
        mounted() {
        },
        methods: {
            // 게시글 새로고침
            boardReload(){
                this.$parent.boardListReload();
            }
        },
    }
</script>
<style scoped>
    .info{position: relative}
    .name .option_popup {display: none;position: absolute;left: 0;top: 0;background: #fff;width: 105px;z-index: 1;border: 1px solid #cccccc;border-radius: 5px;}
    .name .option_popup li {padding: 0;margin-bottom: 0;}
    .name .option_popup li:first-child {background: #f4f4f4;border-top-left-radius: 5px;border-top-right-radius: 5px;}
    .name .option_popup li:first-child a {font-size: 12px; font-weight: 600}
    .name .option_popup li a {display: block;height: 45px; line-height: 45px;font-size: 16px;font-weight: 500;color: #000;padding: 0 15px;}
    .name.on .option_popup {display: block;}

</style>
